/*
 * Copyright Evollis 2022
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

import { loc } from "../../../core/utils";

export const requiredMessage = () => loc`Required`;

const validate = (values) => {
    const errors = {}
    if (!values.sku) {
        errors.sku = requiredMessage()
    }
    if (!values.family) {
        errors.family = requiredMessage()
    }
    if (!values.category) {
        errors.category = requiredMessage()
    }
    if (!values.brand) {
        errors.brand = requiredMessage()
    }
    if (!values.description) {
        errors.description = requiredMessage()
    }
    if (!values.price) {
        errors.price = requiredMessage()
    }
    return errors;
}
export default validate
